import useUrlParams from '../../../../hooks/useUrlParams'
import { useEffect, useMemo, useState } from 'react'
import { DownLinkSvg, ScheduleSvg, UplinkSvg } from '../Svgs'
import { toast } from "react-toastify";
import UpcommingContactsModal from './UpcommingContactsModal';
import CommandCenterService from '../../../../../../service/CommandCenterService';
import { CircularProgress } from '@mui/material';
import useContacts from '../../../../hooks/useContacts';
import { ContactStation } from '../../../../hooks/useGroundContact';
import { v4 as uuidv4 } from "uuid";
import { useSelector } from 'react-redux';
import { MissionStore } from '../../../../../../store/MissionSlice';
import { get_formated_time } from '../../../../utils';
import { get_remaining_time } from '../../planning/utils';
interface ExecuteButtonProps {
    postData: (payload: any) => Promise<void>;
    communicationType: string;
    isFormValid: any;
    formData: any
    openContactModal: boolean;
    setOpenContactModal: React.Dispatch<React.SetStateAction<boolean>>;
    selectedContact: {
        selection_type: 'manual' | 'auto';
        contact_type: string;
        contact: ContactStation;
    } | null;
    setSelectedContact: React.Dispatch<React.SetStateAction<{
        selection_type: 'manual' | 'auto';
        contact_type: string;
        contact: ContactStation;
    } | null>>;
}

const FormSubmit: React.FC<ExecuteButtonProps> = ({ postData, communicationType, isFormValid, formData, openContactModal, setOpenContactModal, selectedContact, setSelectedContact }) => {
    const { dashboard, scenario_id, truetwin_id } = useUrlParams()
    const { contacts, send_operate_task_command, send_operate_tc_command } = useContacts()
    const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);
    const { ongoing_contacts, upcoming_contacts } = contacts
    const [isExecuteEnabled, setIsExecuteEnabled] = useState<boolean>(false);
    const [isValidJsonThere, setIsValidJsonThere] = useState<boolean>(true);
    const [upcommingContacts, setUpcommingContacts] = useState<{
        loading: boolean;
        contacts: any[];
        selected: ContactStation | null;
    }>({
        loading: false,
        contacts: [],
        selected: null,
    })
    const [isUploading, setIsUploading] = useState(false);


    const get_upcomming_gs_contact_details = () => {
        setUpcommingContacts({
            ...upcommingContacts,
            loading: true,
            contacts: [],
        })
        CommandCenterService.getUpcommingGroundContacts(scenario_id, 'all').then((res) => {
            if (res?.['data']) {
                setOpenContactModal(true)
                setUpcommingContacts({
                    ...upcommingContacts,
                    loading: false,
                    contacts: res?.['data'],
                })
            } else {
                setUpcommingContacts({
                    ...upcommingContacts,
                    loading: false,
                    contacts: [],
                })
            }
        }).catch((error) => {
            toast.error('Failed to get upcomming contact details.', { toastId: 'error' });
            setUpcommingContacts({
                ...upcommingContacts,
                loading: false,
                contacts: [],
            })
        })
    }

    const checkSelections = () => {
        const currentForm = sessionStorage.getItem('currentForm');
        const selectedBusComponent = sessionStorage.getItem('selectedBusComponent');
        const selectedTelecommand = sessionStorage.getItem('selectedTelecommand');
        const selectedPayload = sessionStorage.getItem('selectedPayload');
        const selectedSequences = sessionStorage.getItem('selectedSequences');
        const seqDuration = sessionStorage.getItem('seqDuration');
        const value = sessionStorage.getItem('value');
        const busComponent = selectedBusComponent ? JSON.parse(selectedBusComponent) : null;
        const telecommand = selectedTelecommand ? JSON.parse(selectedTelecommand) : null;
        const payload = selectedPayload ? JSON.parse(selectedPayload) : null;
        const sequences = selectedSequences ? JSON.parse(selectedSequences) : null;
        const duration = seqDuration !== null ? seqDuration : '';
        const rawBytes = sessionStorage.getItem('rawBytes');

        if (currentForm === 'bus') {
            setIsExecuteEnabled(busComponent !== null && telecommand !== null && isValidJsonThere);
        } else if (currentForm === 'payload') {
            if (sequences?.label === 'Other Sequences') {
                setIsExecuteEnabled(payload !== null && sequences !== null && duration !== '' && value !== null);
            } else {
                setIsExecuteEnabled(payload !== null && sequences !== null && duration !== '');
            }
        } else if (currentForm === 'raw') {
            setIsExecuteEnabled(isBase64(rawBytes))
        }
    };

    useEffect(() => {
        checkSelections();
        const handleStorageUpdate = () => {
            checkSelections();
        };

        window.addEventListener('storageUpdate', handleStorageUpdate);
        return () => {
            window.removeEventListener('storageUpdate', handleStorageUpdate);
        };
    }, []);

    useEffect(() => {
        const handleValidJSONEvent = (e) => {
            setIsValidJsonThere(e.detail.buttonOn)
            checkSelections()
            if (!e.detail.buttonOn) {
                setIsExecuteEnabled(false)
            }
        };
        window.addEventListener('validJSONEvent', handleValidJSONEvent);
        return () => {
            window.removeEventListener('validJSONEvent', handleValidJSONEvent);
        };
    }, []);

    useEffect(() => {
        checkSelections()
    }, [isValidJsonThere])

    useEffect(() => {
        const close_modal = () => {
            setOpenContactModal(false)
        }
        document.addEventListener('click', close_modal)
        return () => {
            document.removeEventListener('click', close_modal)
        }
    }, [])

    const isBase64 = (str) => {
        if (!str || str === '') {
            // toast.error('Please enter the raw input', { toastId: 'json-error' });
            return false;
        }
        const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;

        // Check if string matches the base64 pattern
        if (!base64Regex.test(str)) {
            toast.error('Invalid base64 string', { toastId: 'json-error' });
            return false;
        }
        try {
            // Try decoding the string to see if it's valid
            window.atob(str);
            toast.dismiss('json-error');
            return true;
        } catch (error) {
            toast.error('Invalid base64 string', { toastId: 'json-error' });
            return false;
        }
    };
    const handleSubmit = () => {
        if (!isFormValid) {
            toast.error('Please fill all required fields', { toastId: 'from-submit' });
            return;
        }
        // Call the upload API
        uploadAPI(
            formData.fileObject,       // file_data
            formData.fileName,         // fileName
        );
    };


    const POLL_INTERVAL_MS = 3000;

    const uploadAPI = (file_data, fileName) => {
        setIsUploading(true); // Set loading state when upload starts
        CommandCenterService
            .postUploadFileConsoleFlatSat(
                truetwin_id,
                fileName,
                formData.appId,
                formData.isLossDetection,
                scenario_id,
                formData.mtuValue,
                formData.delayValue,
                formData.activityTimeoutValue,
                formData.connectionTimeoutValue,
                file_data
            )
            .then((response) => handleUploadResponse(response, setIsUploading))
            .catch((error) => handleUploadError(error, setIsUploading))
            .finally(() => console.log('Upload process finished.'));
    };

    const handleUploadResponse = (response, setIsUploading) => {
        if (response) {
            // toast.success('File uploaded successfully.', { toastId: '0' });
            startStatusPolling(setIsUploading);
        } else {
            setIsUploading(false); // Reset loading state on failure
            toast.error('File upload failed.', { toastId: '0' });
        }
    };

    const handleUploadError = (error, setIsUploading) => {
        console.error('Error uploading file:', error);
        setIsUploading(false); // Reset loading state on error
        toast.error('Error uploading file. Please try again.', { toastId: '0' });
    };

    const startStatusPolling = (setIsUploading) => {
        const intervalId = setInterval(() => pollUploadStatus(intervalId, setIsUploading), POLL_INTERVAL_MS);
    };

    const pollUploadStatus = (intervalId, setIsUploading) => {
        CommandCenterService
            .getUploadStatus(truetwin_id)
            .then((statusResponse) => handleStatusResponse(statusResponse, intervalId, setIsUploading))
            .catch((err) => handlePollingError(err, intervalId, setIsUploading));
    };

    const handleStatusResponse = (statusResponse, intervalId, setIsUploading) => {
        const { status } = statusResponse?.data?.status;
        if (statusResponse?.data?.status === 'Completed') {
            setIsUploading(false); // Reset loading state on failure
            handleFinalStatus(intervalId, 'success', 'File Uploaded successfully.', setIsUploading);
        } else if (statusResponse?.data?.status === 'Pending') {
            // Keep loading state true while pending
            setIsUploading(true); // Reset loading state on failure
        } else if (statusResponse?.data?.status === 'Failed') {
            setIsUploading(false); // Reset loading state on failure
            handleFinalStatus(intervalId, 'error', 'File Upload failed.', setIsUploading);
        }
    };

    const handleFinalStatus = (intervalId, toastType, message, setIsUploading) => {
        toast[toastType](message, { toastId: '1' });
        clearInterval(intervalId);
        setIsUploading(false); // Reset loading state when done
    };

    const handlePollingError = (err, intervalId, setIsUploading) => {
        console.error('Polling error:', err);
        clearInterval(intervalId);
        setIsUploading(false); // Reset loading state on error
    };


    const handleExecute = async () => {
        if (dashboard === 'operate') {
            const contact_id = selectedContact ? selectedContact.contact?.['uniqueId'] : ''
            const execute_now = (selectedContact && selectedContact.contact_type === 'Ongoing') ? true : false
            if (communicationType === 'TT&C') {
                try {
                    const formData = JSON.parse(sessionStorage.getItem('formData') || '{}');
                    const updated_form = {
                        "CommandUid": uuidv4(),
                        "CommandName": formData?.[0]?.CommandName,
                        "Type": formData?.[0]?.Type,
                        "sequenceData": formData?.[0]?.sequenceData,
                    }
                    await send_operate_tc_command(contact_id, execute_now, updated_form);
                    // // Success handling
                    // const clearEvent = new Event('clearFormFields');
                    // window.dispatchEvent(clearEvent);
                    window.dispatchEvent(new Event('storageUpdate'));
                } catch (error) {
                    // Error handling
                    console.error('Failed to post data:', error);
                    toast.error("Something went wrong while executing the command!", { toastId: 'json-error' });
                }

                {/* This commented code might be needed in the future if commands need to be cleared after execution. */ }
                // sessionStorage.removeItem('selectedBusComponent');
                // sessionStorage.removeItem('selectedTelecommand');
                // sessionStorage.removeItem('selectedPayload');
                // sessionStorage.removeItem('selectedSequences');
                // sessionStorage.removeItem('seqParams');
                // sessionStorage.removeItem('seqPowerReq');
                // sessionStorage.removeItem('seqDuration');
                // sessionStorage.removeItem('formData');
                // sessionStorage.setItem('currentForm', '');
                // setIsExecuteEnabled(false);
                window.dispatchEvent(new Event('storageUpdate'));
            } else if (communicationType === 'TASK') {
                const task_type = sessionStorage.getItem('taskType')
                const selected_task = sessionStorage.getItem('selected_task') ? JSON.parse(sessionStorage.getItem('selected_task') || '{}') : null
                const selected_schedule = sessionStorage.getItem('selected_schedule') ? JSON.parse(sessionStorage.getItem('selected_schedule') || '{}') : null

                if (task_type === 'adhoc' && !selected_task) {
                    toast.error("Please select a task!", { toastId: 'json-error' });
                    return
                } else if (task_type === 'schedule' && !selected_schedule) {
                    toast.error("Please select a schedule!", { toastId: 'json-error' });
                    return
                }
                else if (task_type === 'adhoc' && selected_task) {
                    const payload = {
                        contactId: contact_id,
                        taskId: selected_task.taskId,
                    }
                    try {
                        const response = await send_operate_task_command(task_type, execute_now, payload)
                        console.log('response', response);
                    } catch (error) {
                        console.error('Failed to post data:', error);
                    }

                } else if (task_type === 'schedule' && selected_schedule) {
                    const payload = {
                        contactId: contact_id,
                        scheduleId: selected_schedule.ScheduleId,
                    }
                    try {
                        const response = await send_operate_task_command(task_type, execute_now, payload)
                        console.log('response', response);
                    } catch (error) {
                        console.error('Failed to post data:', error);
                    }
                } else if (task_type === 'file') {
                    handleSubmit()
                }
            }
        } else if (dashboard === 'simulation' || dashboard === 'quick-deploy') {
            try {
                const formData = JSON.parse(sessionStorage.getItem('formData') || '{}');

                formData[0].LinkId = selectedContact ? selectedContact?.['uplink']?.['acpBandUid'] : '';
                formData[0].ScheduleId = selectedContact ? selectedContact?.['groundScheduleId'] : formData[0].ScheduleId;
                formData[0].Timestamp = selectedContact ? selectedContact.contact_type === 'Ongoing' ? 0 : (selectedContact?.['startTime'] * 1000) + 10000 : 0;
                await postData(formData);
                // Success handling
                setSelectedContact(null);
                setUpcommingContacts({ ...upcommingContacts, selected: null });
                const clearEvent = new Event('clearFormFields');
                window.dispatchEvent(clearEvent);
                window.dispatchEvent(new Event('storageUpdate'));
            } catch (error) {
                // Error handling
                console.error('Failed to post data:', error);
                toast.error("Something went wrong while executing the command!", { toastId: 'json-error' });
                setSelectedContact(null);
            }

            {/* This commented code might be needed in the future if commands need to be cleared after execution. */ }
            // sessionStorage.removeItem('selectedBusComponent');
            // sessionStorage.removeItem('selectedTelecommand');
            // sessionStorage.removeItem('selectedPayload');
            // sessionStorage.removeItem('selectedSequences');
            // sessionStorage.removeItem('seqParams');
            // sessionStorage.removeItem('seqPowerReq');
            // sessionStorage.removeItem('seqDuration');
            // sessionStorage.removeItem('formData');
            // sessionStorage.setItem('currentForm', '');
            // setIsExecuteEnabled(false);
            window.dispatchEvent(new Event('storageUpdate'));
        }

    };

    useMemo(() => {
        if (!ongoing_contacts) return
        const ongoing_contact = ongoing_contacts?.filter((contact) => contact?.['uplinkConfigured']).sort((a, b) => a.startTime - b.startTime)[0]
        if (!selectedContact || selectedContact?.['selection_type'] === 'auto') {
            setSelectedContact({
                selection_type: 'auto',
                contact_type: 'Ongoing',
                contact: ongoing_contact
            })
        }
    }, [ongoing_contacts])

    const shoe_gs_list_container = dashboard === 'operate' ? 'show_container' : ''
    const button_text = dashboard === 'operate' ? (!ongoing_contacts || (selectedContact && selectedContact?.['contact_type'] === 'Upcomming')) ? 'Schedule Now' : (ongoing_contacts && !selectedContact && ongoing_contacts?.filter((contact) => contact?.['uplinkConfigured'])?.length === 0) ? 'Schedule Now' : 'Execute now' : 'Execute now'
    const show_multicontact = (ongoing_contacts && ongoing_contacts?.filter((contact) => contact?.['uplinkConfigured'])?.length > 0) ? true : false

    if (userData?.["user_roles"]?.[0] === "project_viewer") {
        return null
    }

    const timeUntilNextContact = get_remaining_time(
        Math.round(contacts?.current_time ?? 0),
        Math.round(upcoming_contacts?.[0]?.startTime ?? 0)
    );
    return (
        <div className="form__submit__section__container">
            <div className={`contact__gs__list__container ${shoe_gs_list_container}`}>
                {ongoing_contacts?.map((contact: ContactStation) => (
                    <button
                        key={contact?.['uniqueId']}
                        disabled={!contact?.['uplinkConfigured']}
                        className={`gs__details__container ${contact?.['uniqueId'] === selectedContact?.contact?.['uniqueId'] && 'selected'
                            }`}
                        onClick={() => {
                            setSelectedContact({
                                selection_type: 'manual',
                                contact_type: 'Ongoing',
                                contact: contact,
                            });
                        }}
                    >
                        <div className="w-30p d-flex">
                            {contact?.['uplinkConfigured'] && <UplinkSvg />}
                            {contact?.['downlinkConfigured'] && <DownLinkSvg />}
                        </div>
                        <div className="d-flex flex-column gap-1 w-90">
                            <div className="d-flex w-100 align-items-center justify-content-between">
                                <span className="gs__details__label w-60">{`${contact?.['antennaId'] ? contact?.['antennaId'] : contact?.['groundStationName']
                                    }, ${contact?.['groundStationProperties']?.['country']}`}</span>
                                <span className="gs__details__other__info w-40 text-end">{`${get_formated_time(
                                    contact?.['startTime']
                                )}`}</span>
                            </div>
                            <div className="d-flex w-100 align-items-center justify-content-between">
                                <span className="gs__details__other__info w-60 text-start">
                                    {contact?.['groundStationProviderName']}
                                </span>
                                <span className="gs__details__other__info">{contact?.['bandInfo']?.['bandName']}</span>
                            </div>
                        </div>
                    </button>
                ))}

                {selectedContact?.['contact_type'] === 'Upcomming' && (
                    <div className={`gs__details__container selected`}>
                        <div className="w-30p d-flex">
                            {selectedContact?.['contact']?.['uplinkConfigured'] && <UplinkSvg />}
                            {selectedContact?.['contact']?.['downlinkConfigured'] && <DownLinkSvg />}
                        </div>
                        <div className="d-flex flex-column gap-1 w-90">
                            <div className="w-100 d-flex align-items-center justify-content-between">
                                <span className="gs__details__label w-60">{`${selectedContact?.['contact']?.['antennaId']
                                    ? selectedContact?.['contact']?.['antennaId']
                                    : selectedContact?.['contact']?.groundStationName
                                    }, ${selectedContact?.['contact']?.groundStationProperties?.country}`}</span>
                                <span className="gs__details__other__info w-40 text-end">{`${get_formated_time(
                                    selectedContact?.['contact']?.['startTime']
                                )}`}</span>
                            </div>
                            <div className="d-flex w-100 align-items-center justify-content-between">
                                <span className="gs__details__other__info">
                                    {selectedContact?.['contact']?.['groundStationProviderName']}
                                </span>
                                <span className="gs__details__other__info">
                                    {selectedContact?.['contact']?.['bandInfo']?.['bandName']}
                                </span>
                            </div>
                        </div>

                        <button
                            className="cancel__contact"
                            onClick={(event) => {
                                event.stopPropagation();
                                setUpcommingContacts({ ...upcommingContacts, selected: null });
                                setSelectedContact(null);
                            }}
                        >
                            <i className="fe fe-x" />
                        </button>
                    </div>
                )}

                {upcoming_contacts?.[0] &&
                    upcoming_contacts[0]?.['uniqueId'] !== selectedContact?.contact?.['uniqueId'] && (
                        <button
                            disabled={!upcoming_contacts[0]?.['uplinkConfigured']}
                            className={`gs__details__container ${upcoming_contacts[0]?.['uniqueId'] === selectedContact?.contact?.['uniqueId'] && 'selected'
                                }`}
                            onClick={() => {
                                setSelectedContact({
                                    selection_type: 'manual',
                                    contact_type: 'Upcomming',
                                    contact: upcoming_contacts[0],
                                });
                            }}
                        >
                            <div className="w-30p d-flex">
                                {upcoming_contacts[0]?.['uplinkConfigured'] && <UplinkSvg />}
                                {upcoming_contacts[0]?.['downlinkConfigured'] && <DownLinkSvg />}
                            </div>
                            <div className="d-flex flex-column gap-1 w-90">
                                <div className="d-flex w-100 align-items-center justify-content-between">
                                    <span className="gs__details__label w-60">{`${upcoming_contacts[0]?.['antennaId']
                                        ? upcoming_contacts[0]?.['antennaId']
                                        : upcoming_contacts[0]?.['groundStationName']
                                        }, ${upcoming_contacts[0]?.['groundStationProperties']?.['country']}`}</span>
                                    <span className="gs__details__other__info w-40 text-end">
                                        {timeUntilNextContact}
                                    </span>
                                </div>
                                <div className="d-flex w-100 align-items-center justify-content-between">
                                    <span className="gs__details__other__info w-60 text-start">
                                        {upcoming_contacts[0]?.['groundStationProviderName']}
                                    </span>
                                    <span className="gs__details__other__info">
                                        {upcoming_contacts[0]?.['bandInfo']?.['bandName']}
                                    </span>
                                </div>
                            </div>
                        </button>
                    )}
            </div>

            <div className="form__submit__btn__container">
                <button
                    className={`execute__btn`}
                    onClick={handleExecute}
                    disabled={
                        isUploading || (
                            !isFormValid && (
                                (dashboard !== 'operate' && !isExecuteEnabled) ||
                                (dashboard === 'operate' && communicationType === 'TT&C'
                                    ? !isExecuteEnabled || !selectedContact
                                    : !selectedContact
                                )
                            )
                        )
                    }
                >
                    {isUploading ? "File Uploading In progress..." : button_text} {isUploading && <CircularProgress size={14} className='text-white ms-2' />}
                </button>
                <div className={`schedule__btn__container ${dashboard === 'operate' && 'show_btn small'}`}>
                    <button
                        disabled={upcommingContacts.loading}
                        className={`schedule__btn`}
                        onClick={(event: any) => {
                            event.stopPropagation();
                            setOpenContactModal(!openContactModal);
                        }}
                    >
                        {upcommingContacts.loading ? <CircularProgress size={15} /> : <ScheduleSvg />}
                    </button>

                </div>
            </div>
        </div>
    );
}

export default FormSubmit